import { render, staticRenderFns } from "./type90.vue?vue&type=template&id=c816db24&scoped=true"
import script from "./type90.vue?vue&type=script&lang=js"
export * from "./type90.vue?vue&type=script&lang=js"
import style0 from "./type90.vue?vue&type=style&index=0&id=c816db24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c816db24",
  null
  
)

export default component.exports